import ScrollReveal from '../shared/ScrollReveal'
import GradientText from '../shared/GradientText'
import './ReactiveSection.css'

const todayPlatforms = [
  'Alert AFTER failure — zero warning',
  'No component-level anomaly detection',
  'No automated task creation',
  '€2–3B lost annually in Europe'
]

const ai4solarApproach = [
  { highlight: 'Auto-detects anomalies:', rest: 'strings, inverters, panels & batteries' },
  { highlight: 'Creates maintenance tasks', rest: 'automatically' },
  { highlight: 'ML trains on data —', rest: 'predicts 30–180 days ahead' },
  { highlight: 'Role-based mobile app —', rest: 'crews track tasks & report back' }
]

export default function ReactiveSection() {
  return (
    <section className="reactive-section" id="reactive">
      <div className="container">
        <ScrollReveal className="reactive-header">
          <span className="reactive-eyebrow">// THE PROBLEM</span>
          <h2 className="reactive-title">
            The industry is{' '}
            <GradientText gradient="solar">reactive.</GradientText>
          </h2>
          <p className="reactive-subtitle">
            Today's platforms act only after failure. AI4Solar predicts what's about to break — and dispatches the work to fix it.
          </p>
        </ScrollReveal>

        <div className="reactive-grid">
          <ScrollReveal animation="fadeLeft" className="reactive-column reactive-today">
            <span className="reactive-column-label">Today's platforms</span>
            <ul className="reactive-list">
              {todayPlatforms.map((item, i) => (
                <li key={i} className="reactive-item reactive-item-bad">
                  <span className="reactive-mark">×</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </ScrollReveal>

          <ScrollReveal animation="fadeRight" className="reactive-column reactive-ai4solar">
            <span className="reactive-column-label reactive-column-label-good">AI4Solar approach</span>
            <ul className="reactive-list">
              {ai4solarApproach.map((item, i) => (
                <li key={i} className="reactive-item reactive-item-good">
                  <span className="reactive-mark reactive-mark-good">✓</span>
                  <span>
                    <strong>{item.highlight}</strong> {item.rest}
                  </span>
                </li>
              ))}
            </ul>
          </ScrollReveal>
        </div>
      </div>
    </section>
  )
}
